import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BottomNav from '../../components/BottomNav';
import './index.less';

// Add JSX type declaration
declare global {
  namespace JSX {
    interface IntrinsicElements {
      button: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;
    }
  }
}

interface Event {
  desc: string;
  id: number;
  eventName: string;
  startTime: string;
  endTime: string;
  requiredContribution: number;
  currentContribution: number;
  status: 'SUCCESS' | 'FAILED' | 'IN_PROGRESS';
  experienceReward: number;
  levelRequirement: number;
  coverImage: string;
  allowedTeams: any[];
  achievements: any[];
  participants: any[];
}

const EventsPage: React.FC = () => {
  const { hash } = useParams<{ hash: string }>();
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<'active' | 'ended'>('active');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch('/api/v1/backroomsteamcard/events');
        const data = await response.json();
        setEvents(data);
      } catch (error) {
        console.error('Failed to fetch events:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const activeEvents = events.filter(event => event.status === 'IN_PROGRESS');
  const endedEvents = events.filter(event => event.status !== 'IN_PROGRESS');

  const renderEventCard = (event: Event) => (
    <div
      className="event-card"
      key={event.id}
      onClick={() => navigate(`/events/${hash}/${event.id}`)}
    >
      {event.coverImage && (
        <div className="event-cover">
          <img src={event.coverImage} alt={event.eventName} />
        </div>
      )}
      <div className="event-content">
        <h3 className="event-title">{event.eventName}</h3>
        <div className="event-info">
          <div className="info-item">
            <span><strong>时间: </strong>{new Date(event.startTime).toLocaleDateString()} - {new Date(event.endTime).toLocaleDateString()}</span>
          </div>
          <div className="event-logo">
            {event.allowedTeams.map((team, index) => (
              <div
                key={team.id}
                className="team-logo"
                style={{
                  position: 'absolute',
                  right: `${index * 20}px`,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '2px solid var(--layer-color)',
                  zIndex: event.allowedTeams.length - index
                }}
              >
                <img
                  src={team.logo}
                  alt={team.teamName}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            ))}
          </div>
          <div className="info-item">
            <span><strong>参与团队: </strong>{event.allowedTeams.length === 16 ? '所有团队' : event.allowedTeams.map(team => team.teamName).join(', ')}</span>
          </div>

          <div className="info-item">
            <span><strong>事件描述: </strong>{event.desc}</span>
          </div>
          <div className="info-item">
            <span><strong>奖励: </strong>{event.experienceReward} 经验值{event.achievements.length > 0 && <span> <strong>成就: </strong>{event.achievements.map((achievement) => achievement.achievementName)}</span>}</span>
          </div>
          {activeTab === 'active' ? (
            <div className="info-item">
              <div className="progress-bar">
                <span className='progress-text'>{event.currentContribution} / {event.requiredContribution}</span>
                <div
                  className="progress-fill"
                  style={{
                    width: `${(event.currentContribution / event.requiredContribution) * 100}%`
                  }}
                />
              </div>
            </div>
          ) : (
            <span className={`tag ${event.status === 'SUCCESS' ? 'success' : 'failed'}`}>{event.status === 'SUCCESS' ? '成功' : '失败'}</span>
          )}

        </div>

      </div>




    </div>
  );

  const renderEventsList = (events: Event[]) => (
    events.length > 0 ? (
      <div className="events-grid">
        {events.map(renderEventCard)}
      </div>
    ) : (
      <div className="empty-state">
        <p>暂无事件</p>
      </div>
    )
  );

  return (
    <div className="events-page">
      <div className="content">
        <div className="tabs">
          <button
            className={`tab ${activeTab === 'active' ? 'active' : ''}`}
            onClick={() => setActiveTab('active')}
          >
            正在发生
          </button>
          <button
            className={`tab ${activeTab === 'ended' ? 'active' : ''}`}
            onClick={() => setActiveTab('ended')}
          >
            已结束的
          </button>
        </div>
        <div className="tab-content">
          {activeTab === 'active' ? renderEventsList(activeEvents) : renderEventsList(endedEvents)}
        </div>
      </div>
      <BottomNav hash={hash} />
    </div>
  );
};

export default EventsPage; 